/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

class ApplicationState {
  static setState = null;
  static getState = null;

  /*====================
  getters
  ====================*/
  static getApplicationEnvironments() {
    return ({
      development: String("DEVELOPMENT"),
      production: String("PRODUCTION"),
      testing: String("TESTING")
    });
  }

  /*====================
  state management
  ====================*/
  static error(error) {
    ApplicationState.setState({ error });
  }

  static increment() {
    const { increment } = ApplicationState.getState();
    ApplicationState.setState({ increment: increment + 1 });
  }

  static initialize(getState, setState) {
    ApplicationState.getState = getState;
    ApplicationState.setState = setState;
  }
}
export default ApplicationState;
